import { IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";

/**
 * GenerateIndicadorObraColumns
 */

type Props = {
  onActionEditar: (idObraIndicador: number | null, openState: boolean) => void,
  onActionDeletar: (idObraIndicador: number | null, openState: boolean) => void,
};

export const GenerateIndicadorObraColumns = ({
  onActionEditar,
  onActionDeletar,
}: Props): GridColDef[] => {
  return [
    {
      field: "item",
      filterable: false,
      headerName: "Item",
      width: 50,
      minWidth: 50,
      sortable: false,
      headerAlign: 'center',
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex items-center justify-center text-xs py-2">
            {params.value}
          </div>
        );
      }
    },
    {
      field: "indicador",
      filterable: false,
      headerName: "Indicador",
      flex: 1,
      minWidth: 150,
      sortable: false,
      headerAlign: 'center',
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex items-center text-xs py-2">
            {params.value}
          </div>
        );
      }
    },
    {
      field: "indice",
      filterable: false,
      headerName: "Índice",
      flex: 3,
      minWidth: 150,
      sortable: false,
      headerAlign: 'center',
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex items-center text-xs py-2">
            {params.value}
          </div>
        );
      }
    },
    {
      field: "frequencia",
      filterable: false,
      headerName: "Frequência",
      width: 100,
      minWidth: 100,
      sortable: false,
      headerAlign: 'center',
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex items-center text-xs py-2">
            {params.value}
          </div>
        );
      }
    },
    {
      field: "meta",
      filterable: false,
      headerName: "Meta",
      flex: 2,
      minWidth: 150,
      sortable: false,
      headerAlign: 'center',
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex items-center text-xs py-2">
            {params.value}
          </div>
        );
      }
    },
    {
      field: "resultado",
      filterable: false,
      headerName: "Resultado",
      flex: 2,
      minWidth: 150,
      sortable: false,
      headerAlign: 'center',
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex items-center text-xs py-2">
            {params.value}
          </div>
        );
      }
    },
    {
      field: 'idObraIndicador',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      width: 100,
      minWidth: 100,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton onClick={() => onActionEditar(params.value, true)}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
            </IconButton>

            <IconButton onClick={() => onActionDeletar(params.value, true)}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        );
      }
    },
  ];
}